var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "u8-layout" }, [
    _c("div", { staticClass: "u8-layout-mask" }),
    _c("div", { staticClass: "u8-layout-wrapper", attrs: { flex: "" } }, [
      _c(
        "div",
        {
          staticClass: "u8-theme-sidebar",
          style: {
            width: _vm.collapse ? _vm.sidebarWidthCollapsed : _vm.sidebarWidth,
          },
          attrs: { "flex-box": "0" },
        },
        [_c("u8-sidebar")],
        1
      ),
      _c(
        "div",
        {
          staticClass: "u8-theme-main-container",
          attrs: { "flex-box": "1", flex: "dir:top" },
        },
        [
          _c(
            "div",
            { staticClass: "u8-theme-header", attrs: { "flex-box": "0" } },
            [_c("u8-header")],
            1
          ),
          _c(
            "div",
            { staticClass: "u8-theme-main", attrs: { "flex-box": "1" } },
            [
              _c("transition", { attrs: { name: "fade-scale" } }, [
                _c(
                  "div",
                  {
                    staticClass: "u8-theme-main-layer",
                    attrs: { flex: "dir:top" },
                  },
                  [
                    _c("div", {
                      staticClass: "u8-theme-main-layer__header",
                      attrs: { "flex-box": "0" },
                    }),
                    _c(
                      "div",
                      {
                        staticClass: "u8-theme-main-layer__body",
                        attrs: { "flex-box": "1" },
                      },
                      [
                        _c(
                          "transition",
                          {
                            attrs: {
                              name: _vm.transitionActive
                                ? "fade-transverse"
                                : "",
                            },
                          },
                          [
                            _c("u8-container", [
                              _vm.steps && _vm.steps.length > 0
                                ? _c(
                                    "div",
                                    { staticClass: "u8-theme-curr-pos" },
                                    [
                                      _c(
                                        "el-breadcrumb",
                                        { attrs: { separator: "/" } },
                                        _vm._l(
                                          _vm.steps,
                                          function (step, index) {
                                            return _c(
                                              "el-breadcrumb-item",
                                              {
                                                key: index,
                                                class: {
                                                  "u8-curr-page-pos":
                                                    index ===
                                                    _vm.steps.length - 1,
                                                },
                                              },
                                              [_vm._v(_vm._s(step))]
                                            )
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "div",
                                { staticClass: "u8-theme-content" },
                                [
                                  _c(
                                    "keep-alive",
                                    { attrs: { include: _vm.keepAlive } },
                                    [_c("router-view")],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }